<template>
  <bm-number
    class="bm-currency"
    v-bind="$attrs"
    :min="min"
    :max-decimal-places="maxDecimalPlacesComputed"
    :fixed-decimal-places="true"
    :prefix="prefixComputed"
    :suffix="suffixComputed"
    :value="value"
    @input="$emit('input', $event)"
  ></bm-number>
</template>

<script lang="ts">
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import { defineComponent } from "vue";

export default defineComponent({
  name: "BmCurrency",
  props: {
    value: {
      type: Number,
      required: false,
    },
    prefix: {
      type: String,
      required: false,
    },
    suffix: {
      type: String,
      required: false,
    },
    maxDecimalPlaces: {
      type: Number,
      required: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    quantise: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    suffixComputed(): string {
      return this.suffix || tenantService.settings.currency.symbolSuffix;
    },
    prefixComputed(): string {
      return this.prefix || tenantService.settings.currency.symbolPrefix;
    },
    maxDecimalPlacesComputed(): number {
      return this.maxDecimalPlaces || this.quantise
        ? tenantService.settings.currency.quantisedMaxDecimalPlaces
        : tenantService.settings.currency.maxDecimalPlaces;
    },
  },
});
</script>

<style lang="sass" scoped>
.bm-number
  max-width: 10em
</style>
